

























import { ClientAccount } from '@/shared/clients/client-account';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component
export default class AddProductDialog extends Vue {
    @Prop({ required: true }) public client!: ClientAccount;
    @Prop({ required: true }) public visible!: boolean;

    private isVisible: boolean = this.visible;
    private selectedProduct: string | null = null;

    @Watch('visible')
    private onVisibleChanged(visible: boolean): void {
        this.selectedProduct = null;
        this.isVisible = visible;
    }
    private onCancel(): void {
        this.$emit('cancel');
    }
    private onNext(): void {
        this.$emit('ok', this.selectedProduct);
    }
}
